import { render, staticRenderFns } from "./RelatorioMovimentacaoFinanceiroGrupo.vue?vue&type=template&id=4ec814c7&scoped=true"
import script from "./RelatorioMovimentacaoFinanceiroGrupo.vue?vue&type=script&lang=js"
export * from "./RelatorioMovimentacaoFinanceiroGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec814c7",
  null
  
)

export default component.exports